import ProjectProcurementActivationPage from "../../shared/project-procurement-activation/ProjectProcurementActivationPage";

const ManagementProjectProcurementActivationPage = () => (
  <ProjectProcurementActivationPage source="Management" />
);

export default ManagementProjectProcurementActivationPage;
